import React, { useState } from 'react';
import '../styles/Login.css';
import axiosPost from '../../../helper/axios-helper';
import { useCookies } from 'react-cookie';


export default function Login({ setAccount }) {
    const [ cookies, setCookie, removeCookie ] = useCookies(['account-canto']);
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const login = () => {
        if (!loading) {
            setLoading(true);

            if (!email || !password) {
                console.error("Email and password are required.");
                setLoading(false);
                return;
            }

            const signInData = { email, password };

            axiosPost('account/auth', {}, signInData, (data) => {
                const { success, response } = data;

                if (success) {

                    const accountRaw = data.data;
                    const expirationDate = new Date();
                    expirationDate.setMonth(expirationDate.getMonth() + 1);
                    setCookie('account-canto', accountRaw.auth_token, { path: '/', expires: expirationDate });
                    setAccount(accountRaw);
                } else {
                    console.error("Login failed:", response);
                }

            });

        }
        setLoading(false);
    };

    return (
        <div className='Login'>
            <div className='LoginContainer'>
                <img 
                    src={process.env.PUBLIC_URL + '/assets/nav_logo.png'} 
                    className='DashboardLogo' 
                    style={{ height: '50px' }} 
                    alt="Logo"
                />
                <div className='LoginItem'>
                    <div className='LoginItemPre'>E-mail</div>
                    <input  
                        type='text' 
                        className='LoginItemInput'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <div className='LoginItem'>
                    <div className='LoginItemPre'>Password</div>
                    <input 
                        type='password' 
                        className='LoginItemInput'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <div className='LoginBtn' onClick={login}>
                    {loading ? "Logging in..." : "Log In"}
                </div>
            </div>
            <div className='LoginCircle'></div>
        </div>
    );
}
